import React from 'react'
import { mapPumpUnitToCard } from './pumpCardHelpers'
import PumpStatusTooltip from './PumpStatusTooltip'

const PumpTiles = ({ pumps = [], onSelectPump, waitingLabel = 'Waiting for data…', unbillableLabel = 'Not in subscription' }) => {
  if (!pumps.length) {
    return <div className="fleetEmptyState">{waitingLabel}</div>
  }

  return (
    <div className="fdTiles">
      {pumps.map((unit) => {
        const p = mapPumpUnitToCard(unit)
        return (
          <div
            key={p.id}
            className={`fdPumpTile ${!p.active ? 'fdPumpTile--idle' : ''}${!p.billable ? ' fdPumpTile--unbillable' : ''}`}
            title={!p.billable ? unbillableLabel : undefined}
            onClick={p.selectable ? () => onSelectPump?.(unit) : undefined}
          >
            <div className="fdPumpTileTop">
              <PumpStatusTooltip unit={unit} disabled={!p.billable}>
                <span
                  className={`fdDot${p.billable ? ' fdDot--status' : ''}${p.pulse ? ' fdDot--pulse' : ''}`}
                  style={{ background: p.statusColor, '--fd-active': p.statusColor }}
                />
              </PumpStatusTooltip>
              <div className="fdPumpTileTopText">
                <span className="fdPumpId">{p.name}</span>
                {p.trans && p.trans !== '—' ? (
                  <span className="fdPumpTrans">{p.trans}</span>
                ) : null}
              </div>
            </div>
            <div className="fdPumpMain">
              {p.mainMetrics.map((metric, index) => (
                <div
                  key={metric.key}
                  className={`fdPumpMainRow${index === 0 ? ' fdPumpMainRow--primary' : ''}`}
                >
                  <span className="fdPumpMainLabel">{metric.label}</span>
                  <span className="fdPumpMainValue">{metric.display}</span>
                </div>
              ))}
            </div>
            <div className="fdPumpMetrics">
              {p.metrics.map((metric) => (
                <div key={metric.key} className="fdPumpMetricRow">
                  <span>{metric.label}</span>
                  <span>{metric.display}</span>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default PumpTiles
